import { useEffect } from "react";
import "./Incubation.css";
import { Backtotop, Floatinmenu, Underline, Deptvision, Deptmission, ContactUs_card } from "../../widgets";
import { FaComputer } from "react-icons/fa6";
import { incubation_mission, incubation_vision, incubation_objectives, incubation_menu, incubation_img_corousal } from "../../constants/incubation";

import { RadialMenu, Listformat, Heroimagecarousal } from "../../components";
const incubation_img = "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/incubation/INCUBATION_TN.webp ";

const Incubation = () => {
  useEffect(() => {
    document.title = 'ACCET- Incubation';
  }, []);
  return (
    <div className="incubationdept">
      <Heroimagecarousal
        key={incubation_img_corousal.id}
        title={incubation_img_corousal.title}
        img_list={incubation_img_corousal.img_list}
      />
      <section className="incubationdark">
        <div className="dept_float_menu">
          <Floatinmenu logo={FaComputer} head="Menu" links={incubation_menu} />
        </div>
        <RadialMenu menu_links={incubation_menu} />
        <div className="incubation_abt">
          <Underline heading="About the Forum" />
          <div className="incubationtwo-col">
            <p className="incubation_dept_content">
              The Alagappa Incubation Forum (AIF), established in 2025 as a Section 8 Company under the Companies Act, 2013, operates as a vital part of the Startup Tamil Nadu initiative. It functions as the dedicated incubation arm of Alagappa Chettiar Government College of Engineering and Technology (ACGCET), Karaikudi, which serves as its Host Institution.
              As a Knowledge Partner with EDII-TN (Entrepreneurship Development and Innovation Institute of Tamil Nadu), AIF plays a critical role in fostering entrepreneurship and innovation across the region. The partnership aims to create a robust support system for startups and aspiring entrepreneurs by pooling resources, expertise, and networks.
              The AIF-ACGCET Incubator serves as the official Technology Park of the institution, functioning as the primary hub for all industry-facing activities. It acts as a bridge between academia and the industrial ecosystem, facilitating innovation, entrepreneurship, and collaborative R&D.


            </p>
            <div className="incubation_img_holder">
              <img className="incubation_img" src={incubation_img} />
            </div>
          </div>
          <div className="csetwo-col1">
            <p className="cse_dept_content">

              The Incubator operates as an independent legal entity under the governing Memorandum of Understanding (MoU) with the Institution, empowering it to use campus resources and infrastructure to support technology-led economic development in the region.
              Alagappa Incubation Forum (AIF) is a Section 8 Company established in 2025 under the Companies Act, 2013, functioning under the Startup Tamil Nadu initiative. It operates as the dedicated incubation arm of Alagappa Chettiar Government College of Engineering and Technology (ACGCET), Karaikudi, which serves as the Host Institution
              This forum is committed to establish a thriving startup ecosystem and is actively working toward building partnerships, mobilizing resources, and creating opportunities for budding entrepreneurs.

            </p>
          </div>
        </div>

        <div className="cse_vision_mission">
          <Underline heading="Our Vision & Mission" />
          <Deptvision visiondata={incubation_vision.visiondata} />
          <Deptmission points={incubation_mission} />
        </div>

        <Underline heading="Objectives" />
        <Listformat points={incubation_objectives} />
        <ContactUs_card email={"incubator@accet.ac.in"} phone={9952517118} heading={"Contact Us"} />
      </section>

      <Backtotop />
    </div>
  );
};

export default Incubation;
